import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "../LanguageSelector";
import LOGO from "../../assets/images/CHARGELOGO.png";
import {
  getRegistrationProgressPercent,
  getRegistrationStepProgressPercent,
  REGISTRATION_SETUP_TOTAL_STEPS,
} from "../../helper/constants";
import {
  RegistrationNavbarLogo,
  RegistrationSetupNavbarRoot,
} from "./RegistrationLayout.style";

export const getRegistrationNavbarStepLabel = (
  currentStep,
  totalSteps = REGISTRATION_SETUP_TOTAL_STEPS,
  translate
) =>
  translate("NUTRITION_COMMON_LBL_STEP_OF", {
    current: currentStep,
    total: totalSteps,
  });

export const RegistrationSetupNavbar = ({
  variant = "step",
  stepMeta,
  centerTitle,
  currentStep = 1,
  totalSteps = REGISTRATION_SETUP_TOTAL_STEPS,
  progressPercent,
  onBack,
  showBack = true,
  showProgress = true,
}) => {
  const { t } = useTranslation();
  const isWelcome = variant === "welcome";
  const resolveNavbarTitle = () => {
    if (centerTitle) {
      return centerTitle;
    }
    if (!stepMeta?.navbarTitleKey) {
      return stepMeta?.navbarTitle ?? "";
    }
    const translated = t(stepMeta.navbarTitleKey);
    return translated === stepMeta.navbarTitleKey
      ? stepMeta.navbarTitle ?? translated
      : translated;
  };
  const resolvedCenterTitle = resolveNavbarTitle();
  const resolvedStep = stepMeta?.step ?? currentStep;
  const resolvedProgress =
    progressPercent ??
    (stepMeta
      ? getRegistrationStepProgressPercent(stepMeta, totalSteps)
      : getRegistrationProgressPercent(resolvedStep, totalSteps));
  const stepLabel = getRegistrationNavbarStepLabel(
    resolvedStep,
    totalSteps,
    t
  );
  const showStepNav = !isWelcome && showBack && Boolean(onBack);

  return (
    <>
      <RegistrationSetupNavbarRoot className="registration-layout__navbar">
        <div className="registration-layout__navbar-row">
          <div className="registration-layout__navbar-left">
            {showStepNav ? (
              <div className="registration-layout__navbar-step">
                <button
                  type="button"
                  className="registration-layout__navbar-back-btn"
                  onClick={onBack}
                  aria-label={t("GO_BACK_BUTTON")}
                >
                  ←
                </button>
                <span className="registration-layout__navbar-step-label">
                  {stepLabel}
                </span>
              </div>
            ) : null}
          </div>

          <div
            className={`registration-layout__navbar-center${
              isWelcome ? " registration-layout__navbar-center--welcome" : ""
            }`}
          >
            {resolvedCenterTitle}
          </div>

          <div className="registration-layout__navbar-right">
            <LanguageSelector variant="light" />
            <RegistrationNavbarLogo src={LOGO} alt={t("NUTRITION_COMMON_LBL_LOGO_ALT")} />
          </div>
        </div>
      </RegistrationSetupNavbarRoot>

      {showProgress && (
        <div
          className="registration-layout__navbar-progress"
          role="progressbar"
          aria-valuenow={resolvedProgress}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div
            className="registration-layout__navbar-progress-fill"
            style={{ width: `${resolvedProgress}%` }}
          />
        </div>
      )}
    </>
  );
};
